<template>
  <div>
    <div class="d-flex">
      <v-select
        v-if="service.type === 'LIST-VALUES'"
        :items="service.listValues"
        item-text="value"
        v-model="selectedValue"
        hide-details
        class="panel__selector mx-4 text-body-2"
        :label="$t('ADDITIONAL_SERV_FIELD_SELECTOR')"
        height="75px"
        outlined
      />
    </div>
    <div class="d-flex justify-end">
      <v-btn
        text
        color="primary"
        class="link non-text-transformation display-btn"
        :ripple="false"
        @click="handleCancel"
        >{{ $t('ADDITIONAL_SERV_EXPANSION_BUTTON_CANCEL') }}</v-btn
      >
      <v-btn
        text
        color="primary"
        :ripple="false"
        @click="handleConfirm"
        class="link non-text-transformation display-btn"
        data-cy="save-changes-btn"
        >{{ $t('ADDITIONAL_SERV_EXPANSION_BUTTON_SAVE') }}</v-btn
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'PanelContentSelect',
  props: {
    service: {
      type: Object,
      default: function() {
        return {
          value: 0,
          minValue: 0,
          maxValue: 0,
          desc_key: '',
          selected: null,
          listValues: [],
          type: '',
        }
      },
    },
  },
  data() {
    return {
      selectedValue: this.service.selected,
    }
  },

  methods: {
    handleCancel() {
      this.$emit('onClose')
    },
    handleConfirm() {
      const updatedService = { ...this.service, selected: this.selectedValue }
      this.$emit('onSaveService', updatedService)
      this.$emit('onClose')
    },
  },
}
</script>

<style scoped lang="scss">
.panel {
  @media (min-width: 1080px) {
    &__selector {
      max-width: rem(220);
    }
  }
}
</style>
